import { getTime } from "@gr-common/head/date";
import type { EasingFunc } from "./easings";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getNewScrollPosition(
  from: number,
  to: number,
  currentState: number,
  easingFnc: EasingFunc,
): number {
  return from - (from - to) * easingFnc(currentState);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function scrollToInternal(
  scrollBase: HTMLElement,
  scrollFrom: number,
  scrollTo: number,
  startTime: number,
  duration: number,
  easingFnc: EasingFunc,
): void {
  const base = scrollBase;
  const current = getTime();
  /*                                                                           */
  const start = startTime === 0 ? current - 1 : startTime;
  const currentState = (current - start) / duration;

  /*                              */
  if (currentState > 1) {
    base.scrollTop = scrollTo;
    return;
  }

  /*                                                                 */
  base.scrollTop = getNewScrollPosition(scrollFrom, scrollTo, currentState, easingFnc);

  /*                                        */
  requestAnimationFrame(() => {
    scrollToInternal(scrollBase, scrollFrom, scrollTo, start, duration, easingFnc);
  });
}
